import { defineComponent, ref } from "vue";
import TableList from "@/components/TableList/index.vue";
import { definePropType } from "@types-vue/props";
import ImageContainer from "@/views/creative/components/image-container.vue";
export default defineComponent({
    name: "table-modular",
    components: {
        TableList: TableList,
        ImageContainer: ImageContainer
    },
    props: {
        resourceTable: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var tableListRef = ref();
        var handleSelectionChange = function(val) {
            var _$ref;
            var tableIds = (_$ref = Array.from(val, function(param) {
                var id = param.id;
                return id;
            })) !== null && _$ref !== void 0 ? _$ref : [];
            emit("handleSelection", tableIds);
        };
        var handleSortChange = function(order) {
            emit("handleSortChange", order);
        };
        var handleClickOperation = function(row, type) {
            emit("handleClickOperation", row, type);
        };
        return {
            tableListRef: tableListRef,
            handleSortChange: handleSortChange,
            handleSelectionChange: handleSelectionChange,
            handleClickOperation: handleClickOperation
        };
    }
});
